var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { StatsigClient } from '@statsig/js-client';
import { datadogLogs } from '@datadog/browser-logs';
import { isStaging, tokenHasJob, tokenHasPlatform } from './utils/index';
import { isInternetExplorer } from './utils/browser-detection';
import { mergeUuids } from './clients/link-api/security';
/**
 * NOTE: This will only contain feature flags or experiments computed at
 * Link start up.
 */
export var globalStatsig = {
    featureFlags: {},
    experiments: {},
};
// Create a client instance to be used throughout the application
var statsigClient = null;
// Use local mode if we do not have a valid client key.
var localMode = !process.env.STATSIG_CLIENT_KEY;
// Even in local mode, Statsig wants a key, hence client-dummy.
var statsigClientKey = process.env.STATSIG_CLIENT_KEY
    ? process.env.STATSIG_CLIENT_KEY
    : 'client-dummy';
function boolToStr(bool) {
    return bool ? 'true' : 'false';
}
function getStatsigInitializationStatus(start, timeout) {
    if (!statsigClient)
        return 'Uninitialized';
    datadogLogs.addLoggerGlobalContext('statsig_initialization_debug', {
        reason: statsigClient.loadingStatus,
        msToComplete: Date.now() - start,
        maxTimeout: timeout,
    });
    return statsigClient.loadingStatus;
}
export var STATSIG_NETWORK_ERROR = 'Failed to fetch client config';
export var isStatsigNetworkError = function (error) {
    return error.message === STATSIG_NETWORK_ERROR;
};
export function initializeStatsig(userID, linkTokenPayload, modalSessionId) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var start, TIMEOUT, STATSIG_PROXY, options, statsigUserObj, error_1, proxyError_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    start = Date.now();
                    TIMEOUT = 20000;
                    STATSIG_PROXY = 'https://statsig-proxy.getpinwheel.com/v1';
                    options = {
                        environment: { tier: isStaging() ? 'staging' : 'production' },
                        networkConfig: {
                            preventAllNetworkTraffic: localMode,
                        },
                    };
                    statsigUserObj = {
                        userID: userID,
                        customIDs: {
                            workspace_name: linkTokenPayload.workspaceName,
                            api_key: linkTokenPayload.apiKey,
                        },
                        custom: {
                            mode: linkTokenPayload.mode,
                            multiple_accounts: boolToStr(((_b = (_a = linkTokenPayload.allocation) === null || _a === void 0 ? void 0 : _a.targets) === null || _b === void 0 ? void 0 : _b.length) > 1),
                            language: linkTokenPayload.language,
                            is_reauth: !!linkTokenPayload.accountId,
                            skip_intro_screen: linkTokenPayload.skipIntroScreen,
                            uses_pinwheel_search: !tokenHasPlatform(linkTokenPayload),
                            has_dds_job: tokenHasJob(linkTokenPayload, 'direct_deposit_switch'),
                            modal_session_id: modalSessionId,
                            'smart_branch.enabled': boolToStr((_c = linkTokenPayload.smartBranch) === null || _c === void 0 ? void 0 : _c.enabled),
                            token_has_user_authentication_data: boolToStr(linkTokenPayload.hasUserAuthenticationData),
                        },
                    };
                    // Create the Statsig client
                    statsigClient = new StatsigClient(statsigClientKey, statsigUserObj, options);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 9]);
                    return [4 /*yield*/, statsigClient.initializeAsync({
                            timeoutMs: TIMEOUT,
                        })];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 9];
                case 3:
                    error_1 = _d.sent();
                    if (!(getStatsigInitializationStatus(start, TIMEOUT) !== 'Uninitialized' &&
                        !localMode)) return [3 /*break*/, 8];
                    // Shutdown the existing client
                    return [4 /*yield*/, statsigClient.shutdown()];
                case 4:
                    // Shutdown the existing client
                    _d.sent();
                    // Create a new client with the proxy
                    statsigClient = new StatsigClient(statsigClientKey, statsigUserObj, __assign(__assign({}, options), { networkConfig: __assign(__assign({}, options.networkConfig), { api: STATSIG_PROXY }) }));
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, statsigClient.initializeAsync({
                            timeoutMs: TIMEOUT,
                        })];
                case 6:
                    _d.sent();
                    return [3 /*break*/, 8];
                case 7:
                    proxyError_1 = _d.sent();
                    // If the Statsig config fails to load again, throw an error
                    if (getStatsigInitializationStatus(start, TIMEOUT) !== 'Uninitialized' &&
                        !localMode) {
                        throw new Error(STATSIG_NETWORK_ERROR);
                    }
                    return [3 /*break*/, 8];
                case 8: return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    });
}
/* START INTERNET EXPLORER EXCLUSIONS */
var IE11_FF_EXCLUSIONS = {
    genericLoader: false,
    directDepositForms: false,
    guidedSwitching: false,
};
var IE11_EXP_EXCLUSIONS = {
    // Disabled as this has not yet been tested on IE11
    dynamicLoadingScreen: null,
};
export function fetchDynamicConfigs(linkTokenId) {
    if (linkTokenId === void 0) { linkTokenId = '00000000-0000-0000-0000-000000000000'; }
    if (!statsigClient)
        return {};
    var dc = statsigClient.getDynamicConfig('dc-sec-header-uuid');
    var s = dc.get('curr', '');
    datadogLogs.logger.info('statsig_dc_debug', {
        statsig_dc: { value: dc.value, s: s, linkTokenId: linkTokenId, dc: dc },
    });
    // Set dx to token id in case config is missing
    window.dx = s ? mergeUuids(s, linkTokenId) : linkTokenId;
    return {};
}
export var getDshHeader = function () {
    return window.dx;
};
export function fetchFeatureFlags() {
    if (!statsigClient)
        return {};
    return __assign(__assign({ hideReturnToSearchButton: statsigClient.checkGate('ff-hide-return-to-search-button'), inputRequiredEventEnabled: statsigClient.checkGate('ff-input-required-event-enabled'), skipExitConfirmation: statsigClient.checkGate('ff-skip-exit-confirmation'), skipSuccessOrErrorTerminalScreen: statsigClient.checkGate('ff-skip-success-or-error-terminal-screen'), usingFcra: statsigClient.checkGate('ff-needs-fcra'), genericLoader: statsigClient.checkGate('ff-generic-loader'), cashAppCopyChanges: statsigClient.checkGate('ff-cashapp-copy-changes'), hideNoneOfTheseOnPrematch: statsigClient.checkGate('ff-link-hide-none-of-these-on-prematch'), usingCustomSearch: statsigClient.checkGate('ff-using-custom-search'), 
        // We renamed the offline dds feature to guided switching, but kept the original feature flag name
        guidedSwitching: statsigClient.checkGate('ff-offline-dds'), limitPlatformsHrbSearch: statsigClient.checkGate('ff-limit-platforms-hrb-search'), directDepositForms: statsigClient.checkGate('ff-dd-forms'), useGenericProviderLogos: statsigClient.checkGate('ff-use-generic-provider-logos'), cardSwitch: statsigClient.checkGate('ff-card-switch'), hideShowPassword: statsigClient.checkGate('ff-hide-show-password') }, (isInternetExplorer() ? IE11_FF_EXCLUSIONS : {})), { modalStylingEnabled: statsigClient.checkGate('ff-modal-styling-enabled'), documentUploadsEnabled: statsigClient.checkGate('ff-doc-uploads-customer-facing'), companyConnectEnabled: statsigClient.checkGate('ff-enable-company-connect'), 
        // We need to revisit this FF implementation on CON-700
        bypassSkipRetryableErrorScreen: statsigClient.checkGate('ff-bypass-skip-retryable-error-screen'), screenTransitionLoadingSkeleton: statsigClient.checkGate('ff-screen-transition-loading-skeleton'), focusScreenHeader: statsigClient.checkGate('ff-focus-screen-header'), focusIframeOnLoadFromPortal: statsigClient.checkGate('ff-focus-iframe-on-load-from-portal'), disableRemainderSwitch: statsigClient.checkGate('ff-disable-remainder-switch'), skipDDFormDownload: statsigClient.checkGate('ff-skip-dd-form-download'), adpManualInstructionsFallback: statsigClient.checkGate('ff-adp-manual-instructions-fallback'), manualInstructionsShowARNumbers: statsigClient.checkGate('ff-manual-instructions-show-ar-numbers'), allowBackgroundEligibilityCheck: statsigClient.checkGate('ff-allow-background-eligibility-check'), multiSwitchButton: statsigClient.checkGate('ff-multi-switch-button'), eligibilityCheckWhenTokenHasPlatform: statsigClient.checkGate('ff-eligibility-check-when-token-has-platform'), appClipsAndroidEnabled: statsigClient.checkGate('ff-app-clips-android-enabled'), wizardEnabled: statsigClient.checkGate('ff-link-wizard-enabled'), appClipsWebEnabled: statsigClient.checkGate('ff-app-clips-web-enabled'), nativeLinkScreenshots: statsigClient.checkGate('ff-native-link-screenshots'), skipSuccessScreen: statsigClient.checkGate('ff-skip-success-screen'), forwardAppClipEvents: statsigClient.checkGate('ff-forward-app-clip-events'), androidDDFormsDownloadWorkaround: statsigClient.checkGate('ff-android-dd-forms-download-workaround'), showExitButtonAfterDDFormDownload: statsigClient.checkGate('ff-show-exit-button-after-dd-form-download'), linkOrigamiThemeNext: statsigClient.checkGate('ff-link-origami-theme-next'), allowLinkDarkMode: statsigClient.checkGate('ff-allow-link-dark-mode'), homerMobileSdkEnabled: statsigClient.checkGate('ff-homer-mobile-sdk-enabled') });
}
export function fetchExperiments() {
    if (!statsigClient)
        return {};
    var expConfirmationScreen = statsigClient.getExperiment('exp-confirmation-screen');
    var expDynamicLoadingScreen = statsigClient.getExperiment('exp-dynamic-loading-screen');
    var expSkipEligibilityCheckSingleResult = statsigClient.getExperiment('exp-skip-eligibility-check-single-result');
    var expEligibilityCheckNoMatchNoPopup = statsigClient.getExperiment('exp-eligibility-check-no-match-no-popup');
    var expAlterEligibilityCheckSkip = statsigClient.getExperiment('exp-alter-eligibility-check-skip');
    var expSkipFiringInvalidCredsErrorEvent = statsigClient.getExperiment('exp-invalid-creds-experience-cash-app');
    var expIntroScreenLayout = statsigClient.getExperiment('exp-intro-screen-layout');
    var expSkipIntroScreen = statsigClient.getExperiment('exp-skip-intro-screen');
    var expEligibilityCheckSendToAmazon = statsigClient.getExperiment('exp-eligibility-check-send-to-amazon');
    var expAdpUserEnteredPii = statsigClient.getExperiment('exp-adp-user-entered-pii');
    var expAlwaysShowDeviceBasedPrimer = statsigClient.getExperiment('exp-always-show-device-based-primer');
    return __assign({ skipIntroScreen: expSkipIntroScreen.get('test-group', false), skipFiringInvalidCredsErrorEvent: expSkipFiringInvalidCredsErrorEvent.get('test-group', false), confirmationScreenEnabled: expConfirmationScreen.get('confirmation-screen-enabled', false), dynamicLoadingScreen: expDynamicLoadingScreen.get('test-variant', null), skipEligibilityCheckSingleResult: expSkipEligibilityCheckSingleResult.get('test-group', false), eligibilityCheckNoMatchNoPopup: expEligibilityCheckNoMatchNoPopup.get('test-group', 'control'), alterEligibilityCheckSkip: expAlterEligibilityCheckSkip.get('test-group', false), introScreenLayout: expIntroScreenLayout.get('test-group', false), eligibilityCheckSendToAmazon: expEligibilityCheckSendToAmazon.get('test-group', false), 
        // TODO: CORE-1515 remove user-entered PII experiment
        expAdpUserEnteredPii: expAdpUserEnteredPii.get('test_group', false), alwaysShowDeviceBasedPrimer: expAlwaysShowDeviceBasedPrimer.get('test_group', false) }, (isInternetExplorer() ? IE11_EXP_EXCLUSIONS : {}));
}
